import ArtifactsTab from './ArtifactsTab';

export default ArtifactsTab;
